import React from 'react';
import { uniqBy, prop } from 'ramda';
import { useDatasourceId } from '@/hooks';
import { useSaveQuerySteps as useSaveQueryStepsHook } from '@/features/query-builder/queriesApiSlice';
import Layer from '@/components/layers/Layer';
import { useGetUpdatedSteps } from './useGetUpdatedSteps';

export const useSaveQuerySteps = () => {
  const datasourceId = useDatasourceId();
  const [updatedActiveSteps, updatedInactiveSteps, stepsHash] =
    useGetUpdatedSteps();

  const [mutate, { data }] = useSaveQueryStepsHook();

  React.useEffect(() => {
    if (stepsHash && updatedActiveSteps.length) {
      const stepsToSave = removeDuplicatedSteps(
        updatedActiveSteps
          .concat(
            updatedInactiveSteps.map((l) => l.cloneAndupdateActive(false)),
          )
          .concat(updatedActiveSteps),
      );
      mutate(stepsToSave);
    }
  }, [stepsHash, datasourceId]);

  return data?.queryId;
};

/**
 * This is a PATCH. Ideally we should investigate and rework/rewrite
 * layers.js reducer. Especially MODAL_SAVE_CLICKED action handling.
 */
const removeDuplicatedSteps = uniqBy<Layer, Layer['_id']>(prop('_id'));
